import styled from 'styled-components'
import Img from '../common/img'
import { H2 } from '../common/text'

export const Image = styled(Img)`
  width: 100%;
  padding: 0 10px;
  border-radius: 0 0 30px 30px;
`

export const Title = styled(H2)`
  color: #8FA5C1;
`

export const Container = styled.div`

`

export const NewButton = styled.button`
  color: ${props => (props.isEven ? 'red' : 'blue')}
`

export default Image



// WEBPACK FOOTER //
// ./src/components/home/styled.js